// FIXTURES
export const SET_FIXTURES = 'SET_FIXTURES';
export const SET_FIXTURES_EURO = 'SET_FIXTURES_EURO';
export const UPDATE_LIVESCORES_FIXTURES = 'UPDATE_LIVESCORES_FIXTURES';
export const LIVE_UPDATE_LIVESCORES_FIXTURES = 'LIVE_UPDATE_LIVESCORES_FIXTURES';
export const LIVEODDS_FIXTURES = 'LIVEODDS_FIXTURES';
export const REMOVE_FIXTURE_BY_TEAM = 'REMOVE_FIXTURE_BY_TEAM';
export const SHOW_FIXTURE_BY_TEAM = 'SHOW_FIXTURE_BY_TEAM';
export const SET_EURO_DISPLAY_MODE = 'SET_EURO_DISPLAY_MODE';
export const SET_FIXTURES_ROUTE = 'SET_FIXTURES_ROUTE';
export const SET_FAVORITE_ROUTE = 'SET_FAVORITE_ROUTE';

// ODDS
export const CHANGE_ODDS_DISPLAY_TYPE = 'CHANGE_ODDS_DISPLAY_TYPE';
export const SET_HANDICAP = 'SET_HANDICAP'

// FAVORITE
export const SET_FAVORITE_FIXTURE = 'SET_FAVORITE_FIXTURE';
export const ADD_FAVORITE_TEAM = 'ADD_FAVORITE_TEAM';
export const REMOVE_FAVORITE_TEAM = 'REMOVE_FAVORITE_TEAM';
export const ADD_FAVORITE_LEAGUE = 'ADD_FAVORITE_LEAGUE';
export const REMOVE_FAVORITE_LEAGUE = 'REMOVE_FAVORITE_LEAGUE';
export const ADD_FAVORITE_MATCH = 'ADD_FAVORITE_MATCH';
export const REMOVE_FAVORITE_MATCH = 'REMOVE_FAVORITE_MATCH';
export const ADD_FAVORITE_COUNTRY = 'ADD_FAVORITE_COUNTRY';
export const REMOVE_FAVORITE_COUNTRY = 'REMOVE_FAVORITE_COUNTRY';

// HISTORY
export const SET_HISTORY_FIXTURE = 'SET_HISTORY_FIXTURE';
export const ADD_HISTORY_TEAM = 'ADD_HISTORY_TEAM';
export const REMOVE_HISTORY_TEAM = 'REMOVE_HISTORY_TEAM';
export const ADD_HISTORY_LEAGUE = 'ADD_HISTORY_LEAGUE';
export const REMOVE_HISTORY_LEAGUE = 'REMOVE_HISTORY_LEAGUE';
export const ADD_HISTORY_COUNTRY = 'ADD_HISTORY_COUNTRY';
export const REMOVE_HISTORY_COUNTRY = 'REMOVE_HISTORY_COUNTRY';

// BOOKMAKER
export const CHANGE_BOOKMAKER = 'CHANGE_BOOKMAKER';
export const CHANGE_BOOKMAKER_EXTEND = 'CHANGE_BOOKMAKER_EXTEND';

// SEARCH
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_SEARCH_TEXT_VALUE = 'SET_SEARCH_TEXT_VALUE';
export const SET_CLEAR_FILTER_SEARCH = 'SET_CLEAR_FILTER_SEARCH';
export const SET_CLEAR_HOT_LEAGUE_SEARCH = 'SET_CLEAR_HOT_LEAGUE_SEARCH';
export const SET_LOADING = 'SET_LOADING';
export const ADD_FILTER_VALUE = 'ADD_FILTER_VALUE';
export const REMOVE_FILTER_VALUE = 'REMOVE_FILTER_VALUE';
export const SET_EVENT_DATA = 'SET_EVENT_DATA';
export const SET_TEAMS = 'SET_TEAMS';
export const CHANGE_THEME = 'CHANGE_THEME';
export const SET_DATE_SELECTED = 'SET_DATE_SELECTED';
export const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
export const SET_LEAGUE_SEARCH = 'SET_LEAGUE_SEARCH';
export const SET_HOT_LEAGUE_SEARCH = 'SET_HOT_LEAGUE_SEARCH';
export const SET_TEAM_SEARCH = 'SET_TEAM_SEARCH';
export const SET_MATCH_SEARCH = 'SET_MATCH_SEARCH';
export const SET_COUNTRY_SEARCH = 'SET_COUNTRY_SEARCH';
export const SET_FILTER_LEAGUE = 'SET_FILTER_LEAGUE';
export const SET_FILTER_LEAGUE_TYPE = 'SET_FILTER_LEAGUE_TYPE';
export const SET_FILTER_ROUND = 'SET_FILTER_ROUND';
export const SET_FILTER_ROUND_NAME = 'SET_FILTER_ROUND_NAME';
export const SET_FILTER_DATE = 'SET_FILTER_DATE';
export const SET_FAVORITE_TYPE_ROUTE = 'SET_FAVORITE_TYPE_ROUTE';
export const SET_FAVORITE_STATUS_MATCHES = 'SET_FAVORITE_STATUS_MATCHES';
export const SET_FAVORITE_STATUS_TEAMS = 'SET_FAVORITE_STATUS_TEAMS';
export const SET_FAVORITE_STATUS_LEAGUES = 'SET_FAVORITE_STATUS_LEAGUES';

//PAGING
export const SET_AMOUNT_MATCHES_CURRENT_ALL = 'SET_AMOUNT_MATCHES_CURRENT_ALL';
export const SET_TOTAL_MATCHES_ALL = 'SET_TOTAL_MATCHES_ALL'; 
export const SET_AMOUNT_MATCHES_CURRENT_LIVE = 'SET_AMOUNT_MATCHES_CURRENT_LIVE'; 
export const SET_TOTAL_MATCHES_LIVE = 'SET_TOTAL_MATCHES_LIVE'; 
export const SET_AMOUNT_MATCHES_CURRENT_RESULT = 'SET_AMOUNT_MATCHES_CURRENT_RESULT'; 
export const SET_TOTAL_MATCHES_RESULT = 'SET_TOTAL_MATCHES_RESULT'; 
export const SET_COLLAGE_PAGINATION = 'SET_COLLAGE_PAGINATION'; 

//LEAGUE
export const SET_LEAGUES_RESULT = 'SET_LEAGUES_RESULT';
export const SET_FILTER_LEAGUES = 'SET_FILTER_LEAGUES';
export const SET_FILTER_RESULTS = 'SET_FILTER_RESULTS';
export const SET_HOT_LEAGUES = 'SET_HOT_LEAGUES';
export const SET_ALL_LEAGUES = 'SET_ALL_LEAGUES';
export const SET_HOT_LEAGUES_LOADING = 'SET_HOT_LEAGUES_LOADING';
export const SET_ALL_LEAGUES_LOADING = 'SET_ALL_LEAGUES_LOADING';
export const SET_HOT_LEAGUES_ERROR = 'SET_HOT_LEAGUES_ERROR';
export const SET_ALL_LEAGUES_ERROR = 'SET_ALL_LEAGUES_ERROR';

//TOGGLE
export const SET_TOGGLE_CARD = 'SET_TOGGLE_CARD';
export const SET_TOGGLE_RANK = 'SET_TOGGLE_RANK';
export const SET_TOGGLE_CORNER = 'SET_TOGGLE_CORNER';
export const SET_TOGGLE_HDC = 'SET_TOGGLE_HDC';
export const SET_TOGGLE_OU = 'SET_TOGGLE_OU';
export const SET_TOGGLE_X2 = 'SET_TOGGLE_X2';
export const SET_TOGGLE_SOUND = 'SET_TOGGLE_SOUND';

export const SET_MATCH_ANALYSIS = 'SET_MATCH_ANALYSIS';